export const API_URL = "/api" as string;

type iNodeEnv = "development" | "production";
export const NODE_ENV = (
  process.env.NODE_ENV === "production" ? "production" : "development"
) as iNodeEnv;
